export default __webpack_public_path__ + "static/media/walletAudio.0a124262.mp3";